import React from "react";
import SectionShell from "./SectionShell";

/* Reusable centered gold highlight — clean, no decorative rules */
function GoldHighlight({ children, accent = false }) {
  return (
    <div className="my-6 md:my-8 text-center">
      <p
        className={`font-serif-display italic text-[22px] sm:text-[24px] md:text-[27px] leading-[1.45] max-w-xl mx-auto ${
          accent ? "text-gold" : "text-graphite"
        }`}
      >
        {children}
      </p>
    </div>
  );
}

export default function WhyMattersSection() {
  return (
    <SectionShell
      id="miert-fontos"
      testId="why-matters-section"
      eyebrow="A felismerés szabadsága"
      titleStart="Miért"
      titleAccent="fontos"
      titleEnd=" mindez?"
    >
      <p>
        Mert automatikus emberi működés másokat, vagy a körülményeket hibáztatni. Holott
        érdemes lehet arra ránézni, hogyan értelmezzük a minket körülvevő helyzeteket.
        Itt jönnek be a történetek, nézőpontok, személyes megélések, esetleges sérelmek.
        Sokszor észrevétlen működési mechanizmusokon keresztül tekintünk önmagunkra, a
        kapcsolatainkra és a világra. Máskor azt érezzük, hogy ugyanazok a helyzetek újra
        és újra visszatérnek az életünkbe. Más szereplőkkel, más körülmények között,
        mégis valami ismerős bennük.
      </p>

      <GoldHighlight accent>
        Mintha ugyanannak a történetnek
        <br />
        egy újabb fejezetét élnénk.
      </GoldHighlight>

      <p>
        Nem azért, mert az élet büntetni szeretne bennünket, vagy valamit rosszul
        csinálunk. Sokkal inkább azért, mert van valami, ami szeretne láthatóvá válni.
        Valami, amit addig talán nem vettünk észre. Amíg egy működési mechanizmus
        tudattalan marad, addig szinte észrevétlenül alakítja a döntéseinket, a
        kapcsolatainkat és az életünket. Amikor azonban felismerjük, valami megváltozik.
        Nem feltétlenül kívül, először belül. Megjelenik a választás lehetősége, vagy
        egyszerűen csak egy új nézőpont.
      </p>

      <GoldHighlight accent>
        Ezzel együtt pedig megjelenik a szabadság is.
      </GoldHighlight>

      <p>
        Amit tudatosan látunk, ahhoz már másképp tudunk kapcsolódni. A folyamat célja nem
        az, hogy hibát találjunk önmagunkban. Sokkal inkább az, hogy meglássuk a
        problémának hitt történeteink mögött rejlő lehetőségeket. Mert amikor a
        történetek mögött rejlő mozgató rugók láthatóvá válnak, gyakran az is láthatóvá
        válik, hogy mindig több lehetőségünk volt, mint amennyit addig láttunk.
      </p>

      <GoldHighlight>
        Talán innen kezdődik minden{" "}
        <span className="text-gold">valódi változás</span>.
      </GoldHighlight>
    </SectionShell>
  );
}
